import API, { defaultHeaders, IRI } from '@/api';

const fetchEdit = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  return fetch(`${API}${IRI.user}${payload.id}/`, {
    headers,
    method: 'PUT',
    body: JSON.stringify(payload),
  });
};

export default fetchEdit;
